function calcCheckSummary(items) {
    const arr = {
        sumRaw: 0,
        sum: 0,
        sumOld: 0,
        count: 0,
        discount_value: 0,
        items: items,
        showCheck: false
    };

    items.forEach(item => {
        const price = item.price;
        const oldPrice = item.old_price || item.price;
        arr.count += 1;
        arr.sum    += Number(price)    ? Number(price)    * item.count : 0;
        arr.sumRaw += Number(price)    ? Number(price)    * item.count : 0;
        arr.sumOld += Number(oldPrice) ? Number(oldPrice) * item.count : 0;
        arr.discount_value += Number(item.discount_value) ? Number(item.discount_value) : 0;
    });

    arr.showCheck = arr.count > 1;
    arr.sum = rurFormat.format(arr.sum);
    arr.count += ' ' + declOfNum(arr.count, ['товар', 'товара', 'товаров']);

    if (arr.sumOld > 0 && arr.sumOld !== arr.sumRaw) {
        arr.sumOld = rurFormat.format(arr.sumOld);
        if (arr.discount_value > 0) arr.discount_value = rurFormat.format(arr.discount_value);
    } else {
        arr.sumOld = 0;
    }

    return arr;
}
